import { render, staticRenderFns } from "./SelfAssessment.vue?vue&type=template&id=02c4ebce&scoped=true"
import script from "./SelfAssessment.vue?vue&type=script&lang=js"
export * from "./SelfAssessment.vue?vue&type=script&lang=js"
import style0 from "./SelfAssessment.vue?vue&type=style&index=0&id=02c4ebce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c4ebce",
  null
  
)

export default component.exports